const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const formActions = require('react-redux-form').actions;
const { CnaeProfessionFinder } = require('components/professionTypes/cnaeProfessionFinder');
import { RadioButton } from 'components/RadioButton/RadioButton';
const PropTypes = require('prop-types');
import { formatText, FormattedText } from 'core/i18n';
const { InfoTooltip } = require('components/tooltip/tooltip');
const { mustShowCnaeQuestion } = require('utilities/logicByCountry');
import objectOmitKey from 'utilities/objectOmitKey';

class Cnae extends React.Component {
    constructor(props) {
        super(props);

        this.buildSectorFilter = this.buildSectorFilter.bind(this);
        this.onHandleUpdate = this.onHandleUpdate.bind(this);
    }

    componentDidMount() {
        if (!mustShowCnaeQuestion()) {
            const { handleSave, formActions } = this.props;

            if (handleSave) {
                handleSave('profession', {
                    option: 'No',
                });
            }

            formActions.change('userProfile.profession_cnae_answer', 'No');
        }
    }

    onHandleUpdate() {
        const { userProfile, handleSave, formActions } = this.props;

        if (handleSave) {
            handleSave('profession', {
                option: userProfile['profession_cnae_answer'],
            });
        }

        formActions.reset('userProfile.profession_id');
        formActions.reset('userProfile.profession_category');
    }

    buildSectorFilter() {
        const { onKnowCnaeChange } = this.props;

        if (mustShowCnaeQuestion()) {
            return (
                <>
                    <label>
                        {formatText('cnaeOrCno-cnaeCode')}
                        <InfoTooltip text={<FormattedText value="cnaeOrCno-cnaeTooltip" />} />
                    </label>
                    <RadioButton
                        profileModel="userProfile.profession_cnae_answer"
                        optionsList={[
                            {
                                label: formatText('cnaeOrCno-yes'),
                                value: 'Si',
                            },
                            {
                                label: formatText('cnaeOrCno-no'),
                                value: 'No',
                            },
                        ]}
                        isUpdated={this.onHandleUpdate}
                        disabled={this.props.disabled}
                        focusAnimated
                        onChange={onKnowCnaeChange}
                        {...objectOmitKey(this.props, 'onChange')}
                    />
                </>
            );
        }
    }

    render() {
        const { userProfile, handleSave, disabled, onFieldChange, onActivityChange } = this.props;

        return (
            <>
                {this.buildSectorFilter()}
                <CnaeProfessionFinder
                    answer={userProfile['profession_cnae_answer']}
                    handleSave={handleSave}
                    disabled={disabled}
                    onFieldChange={onFieldChange}
                    onActivityChange={onActivityChange}
                />
            </>
        );
    }
}

module.exports.constructor = Cnae;
module.exports.Cnae = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        options: state.options,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
    })
)(Cnae);

Cnae.propTypes = {
    userProfile: PropTypes.object.isRequired,
};
